import { render, staticRenderFns } from "./InspectionTemplateItemDrawer.vue?vue&type=template&id=71930bce&scoped=true&"
import script from "./InspectionTemplateItemDrawer.vue?vue&type=script&lang=js&"
export * from "./InspectionTemplateItemDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InspectionTemplateItemDrawer.vue?vue&type=style&index=0&id=71930bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71930bce",
  null
  
)

export default component.exports